// extracted by mini-css-extract-plugin
module.exports = {"coverContainer":"cover_coverContainer__uDQLr","videoPreview":"cover_videoPreview__kpxYM","tabs":"cover_tabs___IKwx"};